module.exports = __webpack_public_path__ + "b13a145d24677b73936fc62986aaae23.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/authors/images/police.png
// module id = 853
// module chunks = 3